export function mapMockDataTemplate(object: any): Record<string, Record<string, unknown>> {
  return JSON.parse(JSON.stringify(object).replaceAll('{{year}}', new Date().getFullYear().toString()));
}
